// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ProBadge":"bek_a bhr_rj bhr_rk bhr_vh bhr_eb bhr_vf bhr_gu bhr_kh"};